<template>
  <div class="page">
    <!--头部-->
    <div class="title"><i class="iconfont icon-huishuai"></i>汇率信息浏览</div>
    <div class="page-content">
      <!--新增角色按钮-->
      <el-form style="font: bold" :inline="true" label-width="80px" size="small" :model="formInline">
        <el-form-item label="月份:">
          <el-date-picker v-model="formInline.pullDate" format="yyyy-MM" value-format="yyyy-MM" type="month" placeholder="选择月"> </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="query" style="backgroundcolor: #2a3861; bordercolor: transparent">查询 </el-button>
        </el-form-item>
      </el-form>
      <!-- 表格区域  :loading="loading"-->
      <el-table
        height="calc(100vh - 170px)"
        :data="tableData"
        border
        :header-cell-style="{
          'text-align': 'center',
          background: '#F5F6FA',
          color: '#646E92',
        }"
        style="
          width: 96%;
          margin-top: 10px;
          margin-left: 25px;
          color: #666e92;
          font-size: 14px;
        "
        :cell-style="{ 'text-align': 'center' }"
      >
        <el-table-column prop="code" label="货币代码" fixed width="150" show-overflow-tooltip> </el-table-column>
        <el-table-column prop="rate" label="汇率(%)" width="150" show-overflow-tooltip> </el-table-column>
        <el-table-column prop="name" label="货币名称" width="120" show-overflow-tooltip> </el-table-column>
        <el-table-column prop="fbuyPri" label="现汇买入价" width="100" show-overflow-tooltip></el-table-column>
        <el-table-column prop="fsellPri" label="现汇卖出价" show-overflow-tooltip width="180"> </el-table-column>
        <el-table-column prop="mbuyPri" label="现钞买入价" width="100" show-overflow-tooltip> </el-table-column>
        <el-table-column prop="msellPri" label="现钞卖出价" width="100" show-overflow-tooltip> </el-table-column>
        <el-table-column prop="bankConversionPri" label="银行折算价/中间价" width="220" show-overflow-tooltip> </el-table-column>
        <el-table-column prop="rmbquotUpdateTime" label="汇率更新日期" width="220" :formatter="formatTime" show-overflow-tooltip> </el-table-column>
        <el-table-column prop="createTime" label="汇率拉取日期" width="220" :formatter="formatTime" show-overflow-tooltip> </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import ElRow from "element-ui/packages/row/src/row";
import ElMain from "element-ui/packages/main/src/main";
import ElFooter from "element-ui/packages/footer/src/main";
import moment from "moment";
import SparkMD5 from "spark-md5";
export default {
  components: {
    ElFooter,
    ElMain,
    ElRow,
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
  },
  data() {
    var user = window.sessionStorage["user"];
    return {
      file: {},
      filterText: "" /*树形筛选绑定*/,
      props: {
        /*配置树形权限菜单显示*/
        label: "name",
        children: "children",
      },
      dataTypes: [
        {
          name: "内部",
          id: 11002001,
        },
        {
          name: "外部",
          id: 11002002,
        },
      ],
      data: [{}] /*绑定新增角色树的数据*/,
      formInline: {
        pullDate: new Date(),
      },
      tableData: [],
      btn: false,
      file: {},
      row: "",
      col: "",
      tmpRow: {},
      uploadDialog: false,
      dialogVisible: false,
      flagClick: false
    };
  },
  created() {
    this.query(); /*绑定树*/
  },
  methods: {
    formatTime(row, column) {
      let date = row[column.property];
      if (date === undefined) {
        return "";
      }
      return moment(date).format("YYYY-MM-DD");
    },
    putdata(resp) {
      console.log(resp.data, "resp.data");
      this.$data.tableData = resp.data.data && resp.data.data ? resp.data.data : [];
    },
    query() {
      //条件筛选
      let o = {
        ...this.formInline,
      };
      o.pullDate = moment(o.pullDate).format("yyyy-MM");
      this.axios
        .get("/api/exchange-rmbquot/list", {
          // , sku: this.$data.formInline.sku, type: this.$data.formInline.type
          params: { ...o },
        })
        .then(this.putdata, (err) => {
          console.log("err", err);
        });
    },
  },
  mounted: function() {
    this.active = this.$route.name;
    this.query();
  },
};
</script>

<style lang="less" scoped>
.page {
  width: 100%;
  height: calc(100vh - 70px);
  overflow: hidden;
  .title {
    height: 50px !important;
    color: white;
    font-size: 16px;
    background: #71c19c;
    line-height: 50px;
    font-family: Source Han Sans CN;
    font-weight: 400;
  }
  &-content {
    background-color: white;
    height: calc(100vh - 50px);
    overflow: hidden;
    .el-form{
      width: 100%;
      height: 36px;
      line-height: 36px;
      margin-top: 15px;
    }
  }
  /*分页插件*/
  .el-pagination {
    background-color: #fff;
    padding: 15px;
    text-align: center;
    z-index: 55555;
  }
}
.center-dialog {
  top: 20%;
}
.el-pagination.is-background /deep/ .el-pager li:not(.disabled).active {
  background-color: #71c19c;
}
/*滚动条样式*/
/deep/ .scrollbar {
  white-space: nowrap;
  .el-scrollbar {
    display: flex;
    justify-content: space-around;
    padding: 0 10px;
  }
  /deep/ .el-scrollbar__wrap {
    overflow: scroll;
    width: 110%;
    height: 100%;
  }
}
.ant-card {
  width: 1230px;
  height: 600px;
  background: #ffffff;
  border-radius: 6px;

  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.65);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5;
  list-style: none;
  font-feature-settings: "tnum";
  position: relative;
  transition: all 0.3s;
}
.showAll_dialog {
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  ::v-deep .el-dialog {
    margin: 0 auto !important;
    height: 80%;
    overflow: hidden;
    .el-dialog__body {
      position: absolute;
      left: 0;
      top: 54px;
      bottom: 0;
      right: 0;
      padding: 0;
      z-index: 1;
      overflow: hidden;
      overflow-y: auto;
      // 下边设置字体，我的需求是黑底白字
      color: #ffffff;
      line-height: 30px;
      padding: 0 15px;
    }
  }
}
</style>
